module.exports = __webpack_public_path__ + "static/media/vivi-explicando-esquerda.1e3da527.svg";